//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
        data(){
            return{
                clientHeight:'',//屏幕高度
                clientWidth:'',//屏幕宽度
                phone:0
            }
        },
       
        mounted () {
                this.clientHeight =`${document.documentElement.clientHeight}`;
                this.clientWidth = `${document.documentElement.clientWidth}`;
                window.onresize = function temp() {
                    this.clientHeight = `${document.documentElement.clientHeight}`;
                    this.clientWidth = `${document.documentElement.clientWidth}`;
                };
                window.document.title="星源材质";
         },  
        methods:{
            gourl:function(city){ 
                if(city==5){
                    window.location.href="http://www.senior798.com";
                }else{
                    this.$router.push({path: '/about',query:{city:city}});
                }
            },
        }
  
}



// WEBPACK FOOTER //
// ./src/view/index.vue